import { UpdateOauth2Integration } from '@/connection/integrations/oauth';
import { serializeError } from '@/store/utils/serialize-error';
import { Oauth2Integration } from '@/types/registration.types';
import { ChannelSettingsReducerCreator } from '../types';

const updateOauthIntegrationReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(
    async ({ channel, integration }: { channel: number; integration: Oauth2Integration }, { rejectWithValue }) => {
      try {
        const isOn = await UpdateOauth2Integration(channel, integration);
        return isOn;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        state.oauthIntegration = action.payload;
      },
    }
  );
};

export default updateOauthIntegrationReducer;
